import React, { useContext } from 'react'

import { Card, CircularProgress, Modal, Tooltip } from '@material-ui/core'
import AppBar from '@material-ui/core/AppBar'
import CssBaseline from '@material-ui/core/CssBaseline'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import { useTheme } from '@material-ui/core/styles'
import { AccountCircle } from '@material-ui/icons'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import clsx from 'clsx'

import Routes from '../../Routes'
import Context from '../../context'

import SideBarListItems from './SideBarListItems'
import TopBar from './TopBar'
import useStyles from './styles'
import './styles.scss'

import logo from '../../assets/images/logo-clube-gazeta.png'

function DrawerNavigation() {
  const classes = useStyles()
  const theme = useTheme()
  const { openSideBar, setOpenSideBar, showLoadingModal } = useContext(Context)
  const { user } = useContext(Context)

  const handleDrawerClose = () => {
    setOpenSideBar(false)
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Modal
        open={showLoadingModal}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999999
        }}
      >
        <Card style={{ padding: 24 }}>
          <CircularProgress size={48} />
        </Card>
      </Modal>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: openSideBar
        })}
      >
        <TopBar />
      </AppBar>
      <Drawer
        className={`${clsx(classes.drawer, {
          [classes.drawerOpen]: openSideBar,
          [classes.drawerClose]: !openSideBar
        })} c-menu`}
        variant="permanent"
        anchor="left"
        open={openSideBar}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: openSideBar,
            [classes.drawerClose]: !openSideBar
          })
        }}
      >
        <div className="c-menu__header">
          <img className="c-menu__header__logo" src={logo} alt="Logo Clube da Gazeta do Povo" />
          <IconButton className="c-menu__header__btn" onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Tooltip disableHoverListener={openSideBar} title={user?.name} placement="right" arrow>
          <div className="c-user-area">
            <AccountCircle className="c-user-area__icon" />
            <span className="c-user-area__name">{user?.name}</span>
          </div>
        </Tooltip>
        <SideBarListItems className="c-menu__list" />
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: openSideBar
        })}
      >
        <div className={classes.drawerHeader} />
        <Routes />
      </main>
    </div>
  )
}

export default DrawerNavigation
